// Function to create an optimized version of the image
export const optimizeImage = async (file) => {
    // If it's not an image, return the original file
    if (!file.type.startsWith('image/')) {
      return file;
    }
  
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
  
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
  
          // Calculate new dimensions while maintaining aspect ratio
          const MAX_WIDTH = 1200;
          const MAX_HEIGHT = 1200;
  
          if (width > height) {
            if (width > MAX_WIDTH) {
              height = Math.round((height * MAX_WIDTH) / width);
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width = Math.round((width * MAX_HEIGHT) / height);
              height = MAX_HEIGHT;
            }
          }
  
          canvas.width = width;
          canvas.height = height;
  
          // Create a context with alpha channel enabled to preserve transparency
          const ctx = canvas.getContext('2d', { alpha: true });
          
          // Clear the canvas with a transparent background
          ctx.clearRect(0, 0, width, height);
          
          // Draw the image with high quality settings
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, width, height);
  
          // Determine if the original image is PNG (to preserve transparency)
          const isPNG = file.type === 'image/png';
          
          // Convert to blob with appropriate format and quality
          canvas.toBlob((blob) => {
            // Create a new file from the blob
            const optimizedFile = new File([blob], file.name, {
              // Keep PNG for PNG images to preserve transparency, use JPEG for others
              type: isPNG ? 'image/png' : 'image/jpeg',
              lastModified: Date.now(),
            });
            
            resolve(optimizedFile);
          }, isPNG ? 'image/png' : 'image/jpeg', isPNG ? 1.0 : 0.8); // Use appropriate quality settings
        };
      };
    });
  };
  